import ToggleableButton from "../../../../../components/toggleableButton/toggleableButton";
import {connect} from "react-redux";
import {actionCreators} from "../redux/sagas/productSales/productSales";

export default connect(
  state => ({
    isRadio: true,
    isActive: state.productSales.selectedFilters.group_categories === 2,
    title: "product-sales-group-category"
  }),
  {
    onClick: data => actionCreators.updateGroupCategory(data)
  }
)(ToggleableButton);
